module.exports = __webpack_public_path__ + "img/img23.b872ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img23.png
// module id = 200
// module chunks = 0